import { bookingResponse } from './bookingResponse';

export const ProviderBing = {
  bookingResponse,
};
